import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class SellOutText extends Vue {
  @Prop({ default: () => {} })
    value: ItemObject;

  @Prop({ default: false })
    disabled: boolean;

  data: ItemObject = {};

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n;
    }
  }

  @Watch('data', { deep: true })
  watchData() {
    this.$emit('input', this.data);
  }

  render(h) {
    return (
      <div class="r-mx-20 r-my-10">
        <el-checkbox v-model={this.data.isPre}>预览</el-checkbox>
        <el-form props={{ model: this.data }} label-position="left" label-width="80px" show-message={false} ref="form" disabled={this.disabled}>
          <el-form-item prop="desc.sellOutText" label="售罄文本" rules={{ required: true, trigger: ['blur', 'change'] }}>
            <el-input v-model={this.data.desc.sellOutText} maxlength={12} show-word-limit></el-input>
          </el-form-item>
        </el-form>
      </div>
    );
  }
}
